import React, { useState } from "react";
import App from "./App.jsx";
import { depo } from "./depo.js";

/* Panelde iki şirketin banka bakiyeleri var — açık adreste duramaz.
   Sunucu tanımlıysa parola sunucuda doğrulanır; tanımlı değilse
   panel yerel modda açılır ve bu ekran atlanır. */

export default function Kabuk() {
  const [girisli, setGirisli] = useState(depo.girisliMi());
  const [parola, setParola] = useState("");
  const [hata, setHata] = useState("");
  const [bekliyor, setBekliyor] = useState(false);

  if (girisli) return <App />;
  if (!depo.sunucuVar()) { depo.giris(""); return <App />; }

  const dene = async () => {
    setBekliyor(true); setHata("");
    try {
      const oldu = await depo.giris(parola);
      if (oldu) setGirisli(true);
      else setHata("Giriş yapılamadı.");
    } catch (e) {
      setHata("Giriş yapılamadı.");
    }
    setBekliyor(false);
  };

  return (
    <div style={S.sayfa}>
      <style>{KILIT_CSS}</style>
      <div style={S.kutu}>
        <div style={S.marka}>
          <span style={S.rozet}>K&amp;S</span>
          <div>
            <div style={S.ad}>Panel</div>
          </div>
        </div>

        <label style={S.etiket} htmlFor="parola">Parola</label>
        <input id="parola" type="password" value={parola} autoFocus
          onChange={(e) => setParola(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && parola && dene()}
          style={S.giris} placeholder="••••••••••" />

        {hata && <div style={S.hata}>{hata}</div>}

        <button style={{ ...S.dugme, opacity: bekliyor || !parola ? 0.5 : 1 }}
          disabled={bekliyor || !parola} onClick={dene}>
          {bekliyor ? "Kontrol ediliyor…" : "Panele gir"}
        </button>

      </div>
    </div>
  );
}

const S = {
  sayfa: { minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
    background: "#FFFFFF", padding: 20 },
  kutu: { width: "100%", maxWidth: 360, border: "1px solid #D9D9DE", borderRadius: 12, padding: "30px 28px 24px",
    boxShadow: "0 1px 3px rgba(16,16,20,.06)" },
  marka: { display: "flex", gap: 12, alignItems: "center", marginBottom: 26 },
  rozet: { fontFamily: "'Instrument Serif',Georgia,serif", fontSize: 19, color: "#F5F8FF",
    background: "linear-gradient(140deg,#3E60B8,#283F7E)", padding: "8px 9px 9px", borderRadius: 5 },
  ad: { fontSize: 15, fontWeight: 600, color: "#0B0B0D", letterSpacing: "-.01em" },
  etiket: { display: "block", fontSize: 11, fontWeight: 600, letterSpacing: ".05em",
    textTransform: "uppercase", color: "#45454C", marginBottom: 7 },
  giris: { width: "100%", padding: "10px 12px", fontSize: 14, border: "1px solid #D9D9DE",
    borderRadius: 6, outline: "none", boxSizing: "border-box", color: "#0B0B0D" },
  hata: { marginTop: 10, fontSize: 13, color: "#C0271A" },
  dugme: { width: "100%", marginTop: 16, padding: "10px 14px", fontSize: 14, fontWeight: 600,
    color: "#F5F8FF", background: "linear-gradient(150deg,#3E60B8,#283F7E)", border: 0,
    borderRadius: 6, cursor: "pointer" },
};

const KILIT_CSS = `
@import url('https://fonts.googleapis.com/css2?family=Instrument+Serif&family=Inter:wght@400;500;600&display=swap');
input:focus{border-color:#3E60B8!important;box-shadow:0 0 0 3px rgba(62,96,184,.13)}
button:hover:not(:disabled){filter:brightness(1.06)}
`;
